// extracted by mini-css-extract-plugin
export default {"svg":"MenuSvg_svg__2a71F"};